import React from "react";
import ReactDOM from "react-dom/client";
import ScrollToTop from "./ScrollToTop";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./utils/i18n";  // 👈 Initialize i18next before rendering

import { CommonContext } from "./context/commonContext";
import { LanguageProvider } from "./context/languageContext";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import 'leaflet/dist/leaflet.css';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <BrowserRouter basename="/">
      <LanguageProvider>
        <CommonContext>
          <ScrollToTop>
            <GoogleOAuthProvider clientId="969788662683-rfptvlffuia8ldgldk0mmlb5phq3t9h6.apps.googleusercontent.com">
              <GoogleReCaptchaProvider reCaptchaKey="6Lc267ssAAAAACO3wT3g9_eKPkpwwgAV-TfM6y5e">
                <App/>
              </GoogleReCaptchaProvider>
            </GoogleOAuthProvider>
          </ScrollToTop>
        </CommonContext>
      </LanguageProvider>
    </BrowserRouter>
);
